import { Box, Link, Text } from "@seneca/senekit";

import ControlledCheckbox from "seneca-common/utils/form-hook/inputs/ControlledCheckbox";
import { requireCheckboxChecked } from "seneca-common/utils/form-hook/utils/validationFunctions";

import { getAppName } from "features/common/utils/functions/app";
import { useTermsAndConditionsLinkByVariant } from "features/sign-up/hooks";

type Props = {
  name?: string;
};

export function TermsAndConditionsCheckbox({
  name = "termsAndConditions"
}: Props) {
  const appName = getAppName();

  return (
    <ControlledCheckbox
      name={name}
      label={<Label text={`I agree to ${appName}'s`} />}
      validateObj={requireCheckboxChecked(
        `You must agree to the Terms and Conditions to use ${appName}`
      )}
    />
  );
}

export function TermsAndConditionsLink() {
  const appName = getAppName();

  return <Label text={`By signing up, you agree to ${appName}'s`} />;
}

function Label({ text }: { text: string }) {
  const termsAndConditionsLink = useTermsAndConditionsLinkByVariant();

  return (
    <Box display="flex" justifyContent="center">
      <Text size="small" tone="neutral" emphasis="medium" align="center">
        {text}{" "}
        <Link
          tone="neutral"
          emphasis="medium"
          fontWeight="normal"
          underline
          to={termsAndConditionsLink}
        >
          Terms & Conditions
        </Link>
      </Text>
    </Box>
  );
}
